<template>
  <div style="display: contents" :class="['action-list', { 'action-list--loading': isLoading }]">
    <slot name="top" />
    <template v-for="{ label, items } in categories">
      <strong v-if="label">{{ label }}</strong>
      <hr v-else />
      <template v-for="(item, index) in items">
        <Action v-if="!item.items" :key="(label || 'default') + index + 'action'" :value="item" v-on="$listeners" />
        <ActionDropdown
          v-else
          :key="(label || 'default') + index + 'dropdown'"
          :value="item.items"
          :label="item.name"
          :icon="item.icon || null"
          placement="left-start"
          v-on="$listeners"
        />
      </template>
    </template>
    <hr v-if="$slots.bottom && value.length" />
    <slot name="bottom" />
  </div>
</template>

<script>
import Action from './Action'
import { SortByKey } from '@/utils'

export default {
  name: 'ActionList',
  props: {
    value: Array,
    isLoading: Boolean,
  },
  computed: {
    categories() {
      const defaults = []
      const primary = []
      const exports = []
      const result = this.value.reduce((res, cur) => {
        if (!cur.category) defaults.push(cur)
        else if (cur.category === 'util') primary.push(cur)
        else if (cur.category === this.$t('export')) exports.push(cur)
        else {
          res[cur.category] = res[cur.category] || []
          res[cur.category].push(cur)
        }

        return res
      }, {})

      return [
        { items: defaults },
        ...Object.entries(result)
          .map(([k, v]) => ({ label: k, items: v }))
          .sort(SortByKey('label')),
        { label: this.$t('export'), items: exports },
        { items: primary },
      ].filter(({ items }) => items.length)
    },
  },
  components: {
    Action,
    ActionDropdown: () => import('./Dropdown'),
  },
}
</script>

<style lang="scss">
.action-list {
  &--loading {
    & > .action-button-wrapper,
    & > .action-dropdown {
      visibility: hidden;
      height: 0;
    }

    & > hr,
    & > strong {
      display: none;
    }
  }

  &:not(:first-child):has(strong:first-child) {
    & > strong:first-child {
      border-top: 1px solid var(--border-color);
      padding: 0.75rem 1rem 0.25rem 1rem;
      margin-top: 0.25rem;
    }
  }
}
</style>
